import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import { Link } from "react-router-dom";

const eventTypes = [
  {
    icon: "ri-heart-fill",
    title: "חתונות ובת/בר מצווה",
    desc: "השארנו את כל האורחים מבושמים מבשר עד היום! הפוד טראק היה מרכז החגיגה.&nbsp;",
    // אנשים מרימים כוסיות - חגיגה משפחתית
    img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/62d1984421411eb5be415be7dc8e819b.jpeg",
  },
  {
    icon: "ri-building-fill",
    title: "אירועי חברה",
    desc: "מושלם לימי גיבוש, מסיבות סוף שנה ואירועי חברה. יוצרים אווירה מיוחדת שמחברת בין עובדים סביב חוויית בשרים משותפת.",
    // שולחן בשרים גדול עם אנשים מסביב - אירוע קבוצתי
    img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/de0fe99cf7ba247d02f1ea44e8242cc1.jpeg",
  },
  {
    icon: "ri-cake-fill",
    title: "ימי הולדת ומסיבות",
    desc: "הפכו את יום ההולדת לחוויה קולינרית. מגיעים לגינה הפרטית, לחצר, לכל מקום שתבחרו. אווירה משוחררת עם שפע בשרים על השולחנות.",
    // ליאור עם כובע מגיש לאורחת - יום הולדת 40
    img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/04ffda9dd4bb642c55a58bfa59cbb2d9.jpeg",
  },
  {
    icon: "ri-group-fill",
    title: "מסיבות רווקים ורווקות",
    desc: "חוויה אחרת לגמרי לפני החתונה. בשרים מעושנים, אווירת פסטיבל ורגעים שלא ישכחו.",
    // חגיגה עם חברים ושוטים - אווירת מסיבה
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/ee3da90d-1b93-455a-90eb-acbd68d165a7_WhatsApp-Image-2026-04-09-at-18.38.29-3.jpeg?v=d5d6ae94e9369edf24873010c149cbbb",
  },
];

const testimonials = [
  {
    name: "שירה ואלון כהן",
    event: "חתונה - 220 אורחים",
    text: "\"הבשר היה פשוט מדהים! כל האורחים דיברו על זה כל הערב. ליאור הגיע בזמן, הכל היה מסודר ומקצועי ברמה הכי גבוהה. ממליצים בחום לכל זוג!\"",
    stars: 5,
  },
  {
    name: "דני לוי - מנהל HR",
    event: "אירוע חברה - 150 עובדים",
    text: "\"הזמנו את העגלה לאירוע השנתי של החברה ולא התאכזבנו. הבריסקט נמס בפה, האסאדו היה מושלם. כל העובדים ביקשו שנחזור לאותו קייטרינג בשנה הבאה.\"",
    stars: 5,
  },
  {
    name: "מיכל אברהם",
    event: "יום הולדת 40 - גינה פרטית",
    text: "\"חוויה בלתי נשכחת! החיתוך הפרונטלי מול האורחים יצר אווירה מדהימה. כולם ביקשו את הפרטים של ליאור. שירות אישי ברמה הכי גבוהה.\"",
    stars: 5,
  },
];

const Events = () => {
  return (
    <div className="min-h-screen bg-[#faf7f2]" dir="rtl">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 pb-0 overflow-hidden">
        <div className="relative h-[420px] md:h-[520px] w-full">
          <img
            src="https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/12212c452fa7c694fb7e649bcf56cdb6.jpeg"
            alt="אירועים עם Meet n' Meat"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-black/70 via-black/40 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <div className="max-w-xl">
                <span
                  className="inline-block bg-[#e85d04]/20 text-[#f4a261] border border-[#e85d04]/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  אירועים עם הפוד טראק
                </span>
                <h1
                  className="text-white font-black text-4xl md:text-6xl leading-tight mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  פסטיבל בשרים
                  <br />
                  <span className="text-[#e85d04]">בכל אירוע שלכם</span>
                </h1>
                <p
                  className="text-white/80 text-lg"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  מגיעים עם כל הציוד, הבשרים והצוות. אתם רק מביאים את האורחים.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Types */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <span
              className="inline-block bg-[#e85d04]/10 text-[#e85d04] px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              סוגי אירועים
            </span>
            <h2
              className="text-[#1a0a00] font-black text-4xl md:text-5xl"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              לכל אירוע
              <br />
              <span className="text-[#e85d04]">יש לנו פתרון</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
            {eventTypes.map((ev) => (
              <div key={ev.title} className="bg-[#faf7f2] rounded-2xl overflow-hidden flex flex-col sm:flex-row">
                <div className="w-full sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={ev.img}
                    alt={ev.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#e85d04]/15 rounded-lg">
                      <i className={`${ev.icon} text-[#e85d04] text-base`}></i>
                    </div>
                    <h3
                      className="text-[#1a0a00] font-bold text-lg"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    >
                      {ev.title}
                    </h3>
                  </div>
                  <p
                    className="text-[#7a5c44] text-sm leading-relaxed"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {ev.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Experience */}
      <section className="py-20 bg-[#1a0a00]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div>
              <span
                className="inline-block bg-[#e85d04]/20 text-[#f4a261] px-4 py-1.5 rounded-full text-sm font-semibold mb-6"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                חוויית האירוח
              </span>
              <h2
                className="text-white font-black text-3xl md:text-4xl mb-6 leading-tight"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                עמדת חיתוך והגשה
                <br />
                <span className="text-[#e85d04]">שהיא מופע בפני עצמה</span>
              </h2>
              <div
                className="text-white/70 text-base leading-relaxed space-y-4"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                <p>
                  השירות אינו רק הגשת אוכל - זהו מופע קולינרי שלם. האורחים ניגשים לעגלה, מקבלים הסבר מפורט על הנתחים השונים ובוחרים את מה שהם הכי אוהבים. ליאור חותך את הבשר מולם, מסביר על תהליך העישון ויוצר חיבור אישי עם כל אורח.
                </p>
                <p>
                  התפריט והכמות מותאמים אישית לכל אירוע. בין אם מדובר באירוע חברה יוקרתי הדורש הגשה אלגנטית, ובין אם מדובר במסיבת חברים בחצר שבה הדגש הוא על אווירה משוחררת ושפע בשר - אנחנו מתאימים את עצמנו לכם.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4 mt-8">
                {[
                  { icon: "ri-user-smile-fill", text: "שירות אישי לכל אורח" },
                  { icon: "ri-scissors-cut-fill", text: "חיתוך פרונטלי חי" },
                  { icon: "ri-settings-fill", text: "התאמה אישית מלאה" },
                  { icon: "ri-truck-fill", text: "הגעה לכל מקום" },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#e85d04]/20 rounded-lg flex-shrink-0">
                      <i className={`${item.icon} text-[#e85d04] text-sm`}></i>
                    </div>
                    <span
                      className="text-white/80 text-sm"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    >
                      {item.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/6d6528e3f80fa1eebffbfa7d99284cbf.jpeg"
                alt="עמדת חיתוך והגשה"
                className="w-full h-80 md:h-96 object-cover object-center rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-[#fff8f0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span
              className="inline-block bg-[#e85d04]/10 text-[#e85d04] px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              מה הלקוחות אומרים
            </span>
            <h2
              className="text-[#1a0a00] font-black text-4xl"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              ציטוטים מלקוחות מרוצים
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.name} className="bg-white rounded-2xl p-6 border border-[#f0e0d0]">
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#e85d04] text-sm"></i>
                  ))}
                </div>
                <p
                  className="text-[#3d2010] text-sm leading-relaxed mb-5 italic"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {t.text}
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#e85d04]/15 rounded-full">
                    <i className="ri-user-fill text-[#e85d04]"></i>
                  </div>
                  <div>
                    <div className="text-[#1a0a00] font-bold text-sm" style={{ fontFamily: "'Assistant', sans-serif" }}>{t.name}</div>
                    <div className="text-[#9a7060] text-xs" style={{ fontFamily: "'Assistant', sans-serif" }}>{t.event}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1a0a00]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2
            className="text-white font-black text-3xl md:text-4xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            בואו נתכנן את
            <br />
            <span className="text-[#e85d04]">אירוע הבשרים שלכם</span>
          </h2>
          <p
            className="text-white/60 text-lg mb-8"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            מגיעים לכל מקום בארץ.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              onClick={() => setTimeout(() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }), 100)}
              className="inline-block bg-[#e85d04] hover:bg-[#d44d00] text-white px-10 py-4 rounded-full text-base font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              בואו נתכנן את האירוע ←
            </Link>
            <a
              href="https://wa.me/972542465614"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#25d366] text-[#25d366] hover:bg-[#25d366] hover:text-white px-10 py-4 rounded-full text-base font-bold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              <i className="ri-whatsapp-fill"></i>
              שלחו הודעה בוואטסאפ
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Events;
